/**
 * Every path, written out literally.
 *
 * The API mixes DRF router routes (which REQUIRE a trailing slash) with
 * hand-written `path()` routes (which must NOT have one). A generic joiner
 * would guess wrong and a slash-less POST does not redirect — it fails.
 */
export const ep = {
  // Hand-written routes — no trailing slash.
  me: "/jewelry/me",
  accessMembers: "/access/members",
  accessMember: (telegramId: number) => `/access/members/${telegramId}`,
  accessInvites: "/access/invites",
  facets: "/jewelry/facets",
  prices: "/jewelry/prices/latest",
  signUpload: "/uploads/sign",
  attachments: (pieceId: string) => `/jewelry/pieces/${pieceId}/attachments`,
  attachment: (id: string) => `/attachments/${id}`,
  makePrimary: (id: string) => `/attachments/${id}/make-primary`,

  // Router routes — trailing slash required.
  pieces: "/jewelry/pieces/",
  piece: (id: string) => `/jewelry/pieces/${id}/`,
  restorePiece: (id: string) => `/jewelry/pieces/${id}/restore/`,
  setPublic: (id: string) => `/jewelry/pieces/${id}/public/`,
  rotateCode: (id: string) => `/jewelry/pieces/${id}/rotate-code/`,
  sendQr: (id: string) => `/jewelry/pieces/${id}/send-qr/`,

  // No login: the customer page behind a printed QR tag.
  publicPiece: (code: string) => `/public/pieces/${encodeURIComponent(code)}`,
} as const;
